import { defineMessages } from 'react-intl';

const messages: {
	completedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	completedSubtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customInputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	skipButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	previousQuestion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextQuestion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	questionProgress: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	autoAnswerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	customAnswerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	skippedAnswerLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	completedTitle: {
		id: 'ai-mate.message-actions.ask-question.completedTitle',
		defaultMessage: 'Your answers',
		description:
			'Header title displayed on the completed ask question action card within the AI conversation interface. Shown after the user has answered all questions.',
	},
	completedSubtitle: {
		id: 'ai-mate.message-actions.ask-question.completedSubtitle',
		defaultMessage: '{count, plural, one {{count} question} other {{count} questions}}',
		description:
			'Subtitle text displayed below the header title in the completed ask question action card. Shows the total number of questions that were answered.',
	},
	customInputPlaceholder: {
		id: 'ai-mate.message-actions.ask-question.customInputPlaceholder',
		defaultMessage: 'Tell Rovo what to do',
		description:
			'Placeholder text displayed in the custom text input field at the bottom of the ask question action card. Invites the user to type a custom answer instead of selecting a predefined option.',
	},
	skipButton: {
		id: 'ai-mate.message-actions.ask-question.skipButton',
		defaultMessage: 'Skip',
		description:
			'Button label displayed on the skip button in the ask question action card within the AI conversation interface. When clicked, it skips all remaining questions and cancels the action.',
	},
	previousQuestion: {
		id: 'ai-mate.message-actions.ask-question.previousQuestion',
		defaultMessage: 'Previous question',
		description:
			'Accessibility label for the previous question navigation button in the ask question action card. Navigates to the previous question in a multi-question flow.',
	},
	nextQuestion: {
		id: 'ai-mate.message-actions.ask-question.nextQuestion',
		defaultMessage: 'Next question',
		description:
			'Accessibility label for the next question navigation button in the ask question action card. Navigates to the next question in a multi-question flow.',
	},
	confirmButton: {
		id: 'ai-mate.message-actions.ask-question.confirmButton',
		defaultMessage: 'Confirm',
		description:
			'Button label displayed on the primary action button in the ask question action card. When clicked, it submits all collected answers.',
	},
	questionProgress: {
		id: 'ai-mate.message-actions.ask-question.questionProgress',
		defaultMessage: '{current}\u00a0/\u00a0{total}',
		description:
			'Progress indicator showing the current question number out of the total number of questions. For example "1 / 3" means question 1 of 3.',
	},
	autoAnswerLabel: {
		id: 'ai-mate.message-actions.ask-question.autoAnswerLabel',
		defaultMessage: 'Let Rovo decide',
		description:
			'Label displayed for a skipped question answer, indicating the user chose to let the AI agent decide the answer autonomously.',
	},
	customAnswerLabel: {
		id: 'ai-mate.message-actions.ask-question.customAnswerLabel',
		defaultMessage: 'Custom Prompt',
		description:
			'Label displayed for a custom answer in the completed ask question view, indicating the user typed a custom response instead of selecting a predefined option.',
	},
	skippedAnswerLabel: {
		id: 'ai-mate.message-actions.ask-question.skippedAnswerLabel',
		defaultMessage: 'Skipped',
		description:
			'Label displayed for a skipped question in the completed ask question view, indicating the user chose to skip the question.',
	},
});

export default messages;
